export const loginStart = () => ({
  type: 'LOGIN_START'
})
export const reset = () => ({
  type: 'RESET'
})
export const loginSuccess = (user) => ({
  type: 'LOGIN_SUCCESS',
  payload: user
})
export const loginFailure = (message) => ({
  type: 'LOGIN_FAILURE',
  payload: message
})

export const getUserFailure = (message) => ({
  type: 'GET_USER_FAILURE',
  payload: message
})
export const getUserSuccess = (data, message) => ({
  type: 'GET_USER_SUCCESS',
  payload: data,
  message
})

export const updateUserSuccess = (data, message) => ({
  type: 'UPDATE_SUCCESS',
  payload: data,
  message
})
export const updateUserFailure = (message) => ({
  type: 'UPDATE_FAILURE',
  payload: message
})
export const createUserFailure = (message) => ({
  type: 'CREATE_FAILURE',
  payload: message
})

export const uploadResourceFailure = (message) => ({
  type: 'UPLOAD_FAILURE',
  payload: message
})
export const uploadResourceSuccess = (message) => ({
  type: 'UPLOAD_SUCCESS',
  payload: message
})

export const createUserSuccess = (message) => ({
  type: 'CREATE_SUCCESS',
  payload: message
})
//logout

export const logout = () => ({
  type: 'LOGOUT'
})
